export default class MapController {
    constructor(model) {
        this.model = model;
    }

    /**
     * Display/Render the map.
     */
    show(data) {
        // == Set tiles for the map.
        this.model.setTiles();

        let markers = [];
        let heat = [];

        // == Transform data and store in arrays.
        data.forEach(row => {
            if (this.model.areValidCoordinates(row)) {
                markers.push(this.model.addMarker(row));
                heat.push([row.shape.latitude, row.shape.longitude, 0.4]);
            }
        });

        // == Pass transformed data to Map Model to add Map Layers.
        this.model.addHeat(heat);
        this.model.addMarkerGroups(markers);
    }
}


// WEBPACK FOOTER //
// ./js/Controllers/MapController.js